var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevisionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V20C23.5 21.933 21.933 23.5 20 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z",
    fill: "#F0F1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V20C23.5 21.933 21.933 23.5 20 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z",
    stroke: "#DFDEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26428_12545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2453 4.0031C8.73084 3.87868 5.0324 7.51353 5.0324 12.0016H3.44482C3.04571 12.0016 2.85059 12.4815 3.1344 12.757L5.6089 15.2454C5.78628 15.4231 6.06122 15.4231 6.23861 15.2454L8.71311 12.757C8.98805 12.4815 8.79293 12.0016 8.39382 12.0016H6.80623C6.80623 8.53556 9.62663 5.7361 13.1033 5.78053C16.4027 5.82497 19.1787 8.60665 19.2231 11.9127C19.2674 15.3876 16.4736 18.2226 13.0147 18.2226C11.5867 18.2226 10.2652 17.7338 9.21865 16.9073C8.86388 16.6318 8.36721 16.6584 8.04792 16.9784C7.67541 17.3516 7.70202 17.9826 8.11887 18.3026C9.46698 19.369 11.161 20 13.0147 20C17.4936 20 21.1211 16.2941 20.9969 11.7705C20.8816 7.6024 17.4049 4.11863 13.2453 4.0031ZM12.7929 8.44668C12.4293 8.44668 12.1277 8.74885 12.1277 9.11322V12.3837C12.1277 12.6948 12.2962 12.988 12.5623 13.148L15.3295 14.7921C15.6488 14.9788 16.0568 14.8721 16.243 14.5611C16.4293 14.2411 16.3229 13.8323 16.0124 13.6457L13.4581 12.126V9.10433C13.4581 8.74885 13.1566 8.44668 12.7929 8.44668Z",
    fill: "#C02B65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26428_12545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevisionsIcon);
export default __webpack_public_path__ + "static/media/revisions-icon.8dd933ae.svg";
export { ForwardRef as ReactComponent };